import React, { useCallback, useState } from "react";
import { useTranslation } from "react-i18next";
/**Components**/
import "./ScheduleSetting.scss";

/**Utils**/
import Icons from "../../utils/components/icons";
import ModalComponent from "../../utils/components/common/modalComponent/ModalComponent";
import { getTaskFormattedTime } from "../../utils/utils";

const JobList = (props) => {
  const { listItems, noTaskText, isActionCol, onDeleteJobCB, onEditJobCB } =
    props;
  const taskHeadings = [
    "editedIcon",
    "task",
    "when",
    "action",
    "actionOptions",
  ];
  const { t } = useTranslation("device");
  const [confirmModal, setConfirmModal] = useState({
    open: false,
    msg: "",
    type: "",
    data: {},
  });

  const modesList = {
    OPERATIONAL: t("changeModesTo.operational"),
    SENSE_ONLY: t("changeModesTo.senseOnly"),
    STANDBY: t("changeModesTo.standBy"),
    RESEARCH: t("changeModesTo.research"),
  };

  const decryptCronExp = useCallback((job) => {
    const timeSections = job.jobTime.split(" ");
    let timeWithMinHour;
    if (timeSections.length > 5) {
      timeWithMinHour = timeSections.slice(1).join(" ");
    } else {
      timeWithMinHour = timeSections.join(" ");
    }
    return getTaskFormattedTime(timeWithMinHour, "WEEKLY");
  }, []);

  const onDeleteJobClick = useCallback(
    (index) => {
      /**Open confirmation modal onclick of delete */
      setConfirmModal((prev) => ({
        ...prev,
        open: true,
        msg: t("schdSetting.deleteTaskConfirm"),
        type: "deleteJob",
        data: { selectedIndex: index },
      }));
    },
    [t]
  );

  const onConfirmModalClose = useCallback(() => {
    //Reset on modal close
    setConfirmModal((prev) => ({
      ...prev,
      open: false,
      msg: "",
      type: "",
      data: {},
    }));
  }, []);

  const onConfirm = useCallback(
    (type) => {
      if (type === "deleteJob") {
        /**Delete job logic */
        onDeleteJobCB(confirmModal.data?.selectedIndex);
        setConfirmModal((prev) => ({
          ...prev,
          open: false,
          msg: "",
          type: "",
          data: {},
        }));
      }
    },
    [confirmModal.data, onDeleteJobCB]
  );

  return (
    <>
      <div className="scheduleList">
        <table className="table job-table" id="task-table">
          <thead>
            <tr>
              {taskHeadings.map((heading, i) => {
                return !isActionCol && heading === "actionOptions" ? (
                  ""
                ) : (
                  <td key={heading} className={`${heading} col-${i}`} id={heading}>
                    {t(`taskHeadings.${heading}`)}
                  </td>
                );
              })}
            </tr>
          </thead>
          <tbody>
            {listItems?.length ? (
              listItems?.map((job, i) => {
                return (
                  <tr
                    key={job.jobTime}
                    className={job?.edited ? "edited-job-row" : ""}
                  >
                    <td name="edit-icon">{job?.edited ? Icons.editedJob : ""}</td>
                    <td name="count">{`${i + 1}`}</td>
                    <td name="schd-on">{decryptCronExp(job)}</td>
                    <td name="target-mode">{modesList[job.targetMode]}</td>
                    {isActionCol && (
                      <td className="action-icons" name="action-icons">
                        <span
                          className="edit-action"
                          name="edit-action"
                          title={t("schdSetting.editTaskTooltip")}
                          onClick={() => {
                            onEditJobCB(i);
                          }}
                        >
                          {Icons.editTask}
                        </span>
                        <span
                          className="delete-action"
                          name="delete-action"
                          title={t("schdSetting.deleteTaskTooltip")}
                          onClick={() => {
                            onDeleteJobClick(i);
                          }}
                        >
                          {Icons.deleteJob}
                        </span>
                      </td>
                    )}
                  </tr>
                );
              })
            ) : (
              <tr>
                <td colSpan="6" className="no-job-container" id="no-job-container">
                  {noTaskText}
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      {/* Comfirmation Modal */}
      <ModalComponent
        idName="schedule-confirm-modal"
        isOpen={confirmModal.open}
        onCloseModal={onConfirmModalClose}
        descriptionText={confirmModal.msg}
        needConfirmation={true}
        onConfirm={() => {
          onConfirm(confirmModal.type);
        }}
      />
    </>
  );
};

export default JobList;
